import { render, staticRenderFns } from "./VButtonGoBack.vue?vue&type=template&id=567faa3e&"
import script from "./VButtonGoBack.vue?vue&type=script&lang=js&"
export * from "./VButtonGoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports